

export const frontMatter = {
	sidebar_position: 1,
	description: 'Theming Dockview Components',
	title: 'Theme'
};
export const contentTitle = undefined;
export const metadata = {
  "id": "overview/getStarted/theme",
  "title": "Theme",
  "description": "Theming Dockview Components",
  "source": "@site/docs/overview/getStarted/theme.mdx",
  "sourceDirName": "overview/getStarted",
  "slug": "/overview/getStarted/theme",
  "permalink": "/docs/overview/getStarted/theme",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "sidebarPosition": 1,
  "frontMatter": {
    "sidebar_position": 1,
    "description": "Theming Dockview Components",
    "title": "Theme"
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Installation",
    "permalink": "/docs/overview/getStarted/installation"
  },
  "next": {
    "title": "Contributing",
    "permalink": "/docs/overview/getStarted/contributing"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {CSSVariablesTable, ThemeTable} from '@site/src/components/cssVariables';
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [{
  "value": "Provided themes",
  "id": "provided-themes",
  "level": 2
}, {
  "value": "Build your own theme",
  "id": "build-your-own-theme",
  "level": 2
}, {
  "value": "Customizing Theme",
  "id": "customizing-theme",
  "level": 2
}, {
  "value": "Extending Theme",
  "id": "extending-theme",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    code: "code",
    h2: "h2",
    p: "p",
    pre: "pre",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  }, {FrameworkSpecific} = _components;
  if (!FrameworkSpecific) _missingMdxReference("FrameworkSpecific", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Dockview components accept a ", _jsx(_components.code, {
        children: "theme"
      }), " property which is highly customizable, the theme is largly controlled through CSS however some properties can only be adjusted\nby direct editing variables of the ", _jsx(_components.code, {
        children: "theme"
      }), " object."]
    }), "\n", _jsxs(_components.p, {
      children: ["Firstly, you should import ", _jsx(_components.code, {
        children: "dockview.css"
      }), ":"]
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "JavaScript",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-css",
          children: "@import './node_modules/dockview-core/dist/styles/dockview.css';\n"
        })
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "React",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-css",
          children: "@import './node_modules/dockview-react/dist/styles/dockview.css';\n"
        })
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "Vue",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-css",
          children: "@import './node_modules/dockview-vue/dist/styles/dockview.css';\n"
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "provided-themes",
      children: "Provided themes"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "dockview"
      }), " comes with a number of built-in themes. Each theme is represented as an object that can be imported."]
    }), "\n", _jsxs(_components.p, {
      children: ["For dock components you should pass the theme object to the ", _jsx(_components.code, {
        children: "theme"
      }), " property, for other components such as split, pane and grid views you should\nuse set the themes associated CSS class to the ", _jsx(_components.code, {
        children: "className"
      }), " property."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { themeAbyss } from \"dockview\";\n\n// For dock components\ntheme={themeAbyss}\n\n// For other components\nconst {className} = themeAbyss;\n"
      })
    }), "\n", _jsx(ThemeTable, {}), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["The source code for all themes can be found ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/blob/master/packages/dockview-core/src/theme.scss",
          children: "here"
        }), " and the associated CSS ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/blob/master/packages/dockview-core/src/theme.scss",
          children: "here"
        }), "."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "build-your-own-theme",
      children: "Build your own theme"
    }), "\n", _jsxs(_components.p, {
      children: ["You can define your own ", _jsx(_components.code, {
        children: "DockviewTheme"
      }), " object and pass it to the ", _jsx(_components.code, {
        children: "theme"
      }), " property."]
    }), "\n", _jsx(DocRef, {
      declaration: "DockviewTheme"
    }), "\n", _jsx(_components.h2, {
      id: "customizing-theme",
      children: "Customizing Theme"
    }), "\n", _jsx(_components.p, {
      children: "The provided themes are controlled primarily through a long list of CSS variables which can be modified by the user either entirely for a new theme\nor partial for a modification to an existing theme."
    }), "\n", _jsx(CSSVariablesTable, {}), "\n", _jsx(_components.h2, {
      id: "extending-theme",
      children: "Extending Theme"
    }), "\n", _jsx(_components.p, {
      children: "You can extends existing themes or create new themes."
    }), "\n", _jsxs(_components.p, {
      children: ["As an example if you wanted to extend the ", _jsx(_components.strong, {
        children: "dockview-theme-abyss"
      }), " theme to dislay a within the tabs container you\nmay try:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: ".dockview-theme-abyss {\n  .groupview {\n      &.active-group {\n          > .tabs-and-actions-container {\n              border-bottom: 2px solid var(--dv-activegroup-visiblepanel-tab-background-color);\n          }\n      }\n      &.inactive-group {\n          > .tabs-and-actions-container {\n              border-bottom: 2px solid var(--dv-inactivegroup-visiblepanel-tab-background-color);\n          }\n      }\n  }\n}\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

